"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGameCompletionList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns data about the completion of Curator games by MasochistME members.
 *
 * ### Filter options
 *
 * - `memberId` - filters by member's Steam ID,
 * - `gameId` - filters by game's Steam ID,
 * - `completed` - filters entries by completed games.
 *
 * ### Sort options
 *
 * - `playTime` - sort by game's playtime (in hours),
 * - `completionPercentage` - sort by game's completion percentage,
 * - `mostRecentAchievementDate` - sort by the date of most recent unlocked achievement.
 *
 * ## Usage
 *
 * ```ts
 * const completionsAll: MemberGame[] = await sdk.getGameCompletionList();
 * const completionsOneGame: MemberGame[] = await sdk.getGameCompletionList({ filter: { gameId: 254692 }});
 * const completionsNewest: MemberGame[] =
 *  await sdk.getGameCompletionList({ filter: { completed: true }, sort: { mostRecentAchievementDate: 'desc' }});
 * ```
 *
 * @param params.filter - Filter to apply to returned completions list.
 * @param params.sort - Fields to sort completions list by.
 * @param params.limit - How many completions will get returned.
 */
const getGameCompletionList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { filter, sort, limit } = params;
    const url = `${BASE_URL}/games/completion/list`;
    const gamesResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = gamesResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getGameCompletionList = getGameCompletionList;
